import React from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Stack,
} from "@mui/material";
import dummyData from "./ObjectiviesComponent/DummyData";
import UpdateIcon from "@mui/icons-material/Update";
import GlobalButton from "../../common/GlobalButton"; // Add this import
import UpdateIconDesign from "../../common/UpdateIconQMS"; // Add this import
import LogsIconDesign from "../../common/LogsIconDesign";

export default function QualityObjectivesTable({ onShowLogs }) {
  return (
    <Box sx={{ mt: 0 }}>
      <Paper elevation={0} sx={{ mt: 2, mb: 2 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ color: "#4F46E5" }}>
            Quality Objectives
          </Typography>
          <Stack direction="row" spacing={1}>
            <UpdateIconDesign
              sx={{
                minWidth: 80,
                height: 36,
                px: 2,
                py: 0.5,
              }}
              icon={<UpdateIcon />}
            />

            <LogsIconDesign
              size="small"
              variant="contained"
              sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
            />
          </Stack>
        </Box>

        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ maxHeight: 400 }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "primary.main" }}>
                {[
                  "Description",
                  "Metric",
                  "Frequency",
                  "Current Status",
                  "Supporting File",
                  "Notes",
                ].map((head) => (
                  <TableCell
                    key={head}
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#5A5A5A",
                      color: "white",
                    }}
                    align="center"
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dummyData.map((row, rowIndex) => (
                <TableRow key={rowIndex} hover>
                  {Object.values(row).map((value, colIndex) => (
                    <TableCell key={colIndex} align="center">
                      <TextField
                        fullWidth
                        size="small"
                        value={value} // Changed from placeholder to value
                        variant="outlined"
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
